import React from 'react';

const ChronicConditions = ({ conditions }) => {
  const conditionsArray = conditions.split(',');

  const formattedConditions = conditionsArray.map((condition, index) => {
    const trimmedCondition = condition.trim();
    return (
      <React.Fragment key={index}>
        <span style={{ color: 'var(--crimson)' }}>{trimmedCondition}</span>
        {index < conditionsArray.length - 1 && ', '}
      </React.Fragment>
    );
  });

  return (
    <p className='docpro_mb_0 mb-1'>
      <b>Chronic Conditions: </b>
      {formattedConditions}
    </p>
  );
};

export default ChronicConditions;
